import { Injectable, signal } from '@angular/core';
import { Observable, Subject, EMPTY } from 'rxjs';
import { Alert } from '../../schemas/alert';

@Injectable({
  providedIn: 'root',
})
export class AlertService {
  public alert = signal<Alert | null>(null);

  constructor() {}

  clearMessages() {
    this.alert.set(null);
  }
}
